<script setup>
import {ref, onMounted} from 'vue';
import http from '@/http';

const props = defineProps({locale: String})
const currentLocale = ref(props.locale || 'cs')

const languages = {
  cs: {label: 'Čeština'},
  en: {label: 'English'},
};

const changeLanguage = (lang) => {
  http.post('/set-locale', {locale: lang}).then(() => {
    localStorage.setItem('lang', lang);
    location.reload();
  }).catch((error) => {
    console.error('Error setting locale:', error);
  });
};

onMounted(() => {
  const stored = localStorage.getItem('lang');
  if (stored && stored !== currentLocale.value && languages[stored]) {
    changeLanguage(stored);
  }
});
</script>

<template>
  <div class="language-switcher">
<!--    <div class="d-none d-md-block" v-for="(lang, code) in languages">
      <button class="btn me-3" type="button" :key="code"
              @click="changeLanguage(code)"
              :class="currentLocale === code ? 'btn-primary' : 'btn-secondary'"><h3 class="mb-0">{{ lang.flag }}</h3></button>
    </div>-->
    <div class="dropdown">
      <button class="btn btn-link text-body text-decoration-none dropdown-toggle d-flex align-items-center me-3 fw-medium"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
        {{ currentLocale.toUpperCase() }}
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li v-for="(lang, code) in languages" :key="code">
          <a class="dropdown-item"
             href="#"
             @click.prevent="changeLanguage(code)">
            {{ code.toUpperCase() }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>


<style scoped lang="scss">
.language-switcher {
  display: flex;
  gap: 10px;
}

button {
  padding: 5px 10px;
  cursor: pointer;
  border: 1px solid var(--color-border);
}

button.active {
  cursor: none;
  background: var(--primary);
}
</style>